'use strict';

function CompanyNotificationsService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/notifications/:notificationId', {}, {
    'query': {
      isArray: false
    },
    'queryNotificationsUser': {
    	url: config.apiBase + '/users/:userId/notifications',
    	method: 'GET',
      isArray: false
    },
    'update': {
			method: 'PUT'
    },
    'updateNotificationsUser': {
      url: config.apiBase + '/users/:userId/notifications',
      method: 'PUT'
    }
  });
}

angular.module('dokiv')
  .factory('CompanyNotificationsService', ['$resource', 'config', CompanyNotificationsService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/notifications/CompanyNotificationsService.js
// module id = 365
// module chunks = 0